"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _underscore = _interopRequireDefault(require("./underscore.js"));
var _each = _interopRequireDefault(require("./each.js"));
var _setup = require("./_setup.js");
var _chainResult = _interopRequireDefault(require("./_chainResult.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Add all mutator `Array` functions to the wrapper.
(0, _each.default)(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (name) {
  var method = _setup.ArrayProto[name];
  _underscore.default.prototype[name] = function () {
    var obj = this._wrapped;
    if (obj != null) {
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) {
        delete obj[0];
      }
    }
    return (0, _chainResult.default)(this, obj);
  };
});

// Add all accessor `Array` functions to the wrapper.
(0, _each.default)(['concat', 'join', 'slice'], function (name) {
  var method = _setup.ArrayProto[name];
  _underscore.default.prototype[name] = function () {
    var obj = this._wrapped;
    if (obj != null) obj = method.apply(obj, arguments);
    return (0, _chainResult.default)(this, obj);
  };
});
var _default = exports.default = _underscore.default;